module.exports = __webpack_public_path__ + "img/03094114003151.b449ddfb.png";